<template>
  <div class="row">
    <div class="col-12">
      <!-- Export Buttons -->
      <table-export-buttons
        v-if="surveys?.length"
        :columns="tableColumns"
        :data="surveys"
        file-name="surveys-report"
        title="Surveys Report"
        class="mb-3"
      />

      <div class="table-responsive">
        <table class="table table-hover table-striped">
          <thead>
            <tr>
              <th>Scope</th>
              <th>Project #</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Visits</th>
              <th>Location</th>
              <th>Completed</th>
              <th>Cancelled</th>
              <th>Notes</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(surv, i) in surveys" :key="i">
              <!-- Table view -->
              <td>{{ surv.scope }}</td>
              <td>{{ getProjectNumberForProject(surv.project_id) }}</td>
              <td>
                {{
                  surv.start_date
                    ? moment(surv.start_date).format("DD-MM-YYYY")
                    : ""
                }}
              </td>
              <td>
                {{
                  surv.end_date
                    ? moment(surv.end_date).format("DD-MM-YYYY")
                    : ""
                }}
              </td>
              <td>{{ surv.visits }}</td>
              <td>{{ getSurveyLocation(surv) }}</td>
              <td>
                <i
                  v-if="surv.completed"
                  class="fa fa-check-square text-success"
                ></i>
                <i v-else class="fa fa-square"></i>
              </td>
              <td>
                <i
                  v-if="surv.cancelled"
                  class="fa fa-check-square text-success"
                ></i>
                <i v-else class="fa fa-square"></i>
              </td>
              <td>{{ truncate(surv.notes, 20) }}</td>
              <td class="d-flex">
                <button
                  class="btn btn-sm btn-primary me-2"
                  type="button"
                  @click="openForEdit(i)"
                >
                  Edit
                </button>
                <button
                  class="btn btn-sm btn-danger"
                  title="Remove Surveys"
                  type="button"
                  @click="deleteSurvey(i)"
                >
                  <span class="sr-only">Remove Survey</span>
                  <i class="fa fa-minus"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SurveyEditorModal from "./SurveyEditorModal.vue";
import TableExportButtons from "@/components/tableExport/TableExportButtons.vue";
import moment from "moment";

export default {
  name: "SurveysTable",
  components: {
    TableExportButtons,
  },
  props: {
    surveys: {
      type: Array,
      default: () => [],
    },
    surveyDocuments: {
      type: Array,
      default: () => [],
    },
    projectOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      moment,
    };
  },
  computed: {
    tableColumns() {
      return [
        { key: "scope", label: "Scope" },
        {
          key: "project_id",
          label: "Project #",
          formatter: (val) => this.getProjectNumberForProject(val),
        },
        {
          key: "start_date",
          label: "Start Date",
          formatter: (val) => (val ? moment(val).format("DD-MM-YYYY") : ""),
        },
        {
          key: "end_date",
          label: "End Date",
          formatter: (val) => (val ? moment(val).format("DD-MM-YYYY") : ""),
        },
        { key: "visits", label: "Visits" },
        {
          key: "location",
          label: "Location",
          formatter: (_, row) => this.getSurveyLocation(row),
        },
        {
          key: "completed",
          label: "Completed",
          formatter: (val) => (val ? "Yes" : "No"),
        },
        {
          key: "cancelled",
          label: "Cancelled",
          formatter: (val) => (val ? "Yes" : "No"),
        },
        { key: "notes", label: "Notes" },
      ];
    },
  },
  methods: {
    /* Table row operations */
    openForEdit(index) {
      const field = this.surveys[index];
      this.$modal.show(
        SurveyEditorModal,
        {
          survey: field,
          surveyDocuments: this.getSurveyDocumentsForSurvey(field),
          projectOptions: this.projectOptions,
          onDelete: () => this.deleteSurvey(index),
        },
        {
          name: "survey-editor-modal",
          height: "auto",
          width: "80%",
          scrollable: true,
        },
        {
          "before-close": async (e) => {
            const newValue = e.params?.value;
            if (!newValue) return;
            this.$set(this.surveys, index, newValue);
          },
        }
      );
    },
    deleteSurvey(index) {
      if (confirm("Are you sure you want to delete this Survey?"))
        this.$emit("removeSurveyByIndex", index);
    },
    getProjectNumberForProject(project_id) {
      if (!project_id) return "--";

      const option = this.projectOptions.find((po) => po.value === project_id);
      if (option) {
        return option.text.split(":")[0];
      }
      return "ID: " + project_id;
    },
    getSurveyLocation(survey) {
      if (survey.port && survey.country)
        return survey.port + ", " + survey.country;
      if (survey.port) return survey.port;
      return survey.country;
    },
    getSurveyDocumentsForSurvey(survey) {
      return this.surveyDocuments.filter(
        (doc) => doc.indexOf("/surveys/" + survey.id + "/") > -1
      );
    },
    truncate(text, len) {
      if (!text) return text;
      if (len < 3) {
        console.error("No point in truncating text to less than 3 chars");
        return text;
      }
      if (text.length <= len) {
        return text;
      } else {
        return text.substring(0, len - 3) + "...";
      }
    },
    isInvalid() {
      return false;
    },
  },
};
</script>

<style>
.table tr td .vdp-datepicker {
  white-space: normal;
}

.table-responsive {
  overflow-x: visible;
}
</style>
